import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddDeviceSuccess: FC = () => {
  const { t } = useTranslation();

  return <StatusMessageBox type="success" message={t('common:device_added')} />;
};

export default AddDeviceSuccess;
